export const Loading = require('../resources/img/loading.gif');
export const Back = require('../resources/img/cheveronback.webp');
export const Doc = require('../resources/img/doc.jpeg');
export const DocDisabled = require('../resources/img/docdisabled.png');
export const Upload = require('../resources/img/upload.png');
export const Download = require('../resources/img/download.png');
export const Delete = require('../resources/img/del.jpeg');
export const Cheveron = require('../resources/img/cheveron.png');
export const Close = require('../resources/img/close.png');
export const Search = require('../resources/img/search.jpeg');
export const Phone = require('../resources/img/phone.png');
export const PCLOGO = require('../resources/img/PCLOGO.png');
export const CHEVERONRIGHT = require('../resources/img/ChevronRightSharp.png');
export const PlaceHolder = require('../resources/img/placeholder.png');